import { useState, useRef, useEffect } from "react";
import classnames from "classnames";
import FormLabel from "./FormLabel";
import { DropdownProps, DropDownItemChoice } from "./Dropdown";
import useUniqueId from "./useUniqueId";

function SearchableDropdown(props: DropdownProps) {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const wrapperRef = useRef(null);

    const inputId = useUniqueId("SearchableDropdown");

    const filteredChoices =
        props.choices?.filter((choice: DropDownItemChoice) =>
            choice.label.toString().toLowerCase().includes(searchText.toLowerCase())
        ) || [];

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                wrapperRef.current &&
                event.target instanceof Node &&
                !(wrapperRef.current as Node).contains(event.target)
            ) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="usa-form-group" ref={wrapperRef}>
            <FormLabel
                inputId={inputId}
                hint={props.hint}
                errorMsg={props.errorMsg}
            >
                {props.label}
                {props.mandatoryLabel && <span className="usa-mandatory-label">*</span>}
            </FormLabel>

            {/* Custom dropdown trigger */}
            <div
                className="usa-select"
                onClick={() => setOpen(!open)}
                style={{ cursor: "pointer" }}
            >
                {props.value || props.emptyChoiceLabel}
            </div>

            {open && (
                <div
                    className="usa-select-menu"
                    style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        background: "white",
                        position: "absolute",
                        width: "100%",
                        zIndex: 10,
                    }}
                >
                    {/* Search inside dropdown */}
                    <input
                        type="text"
                        className="usa-input"
                        placeholder="Search..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ marginBottom: "8px", height: "35px" }}
                    />

                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                        {filteredChoices.map((choice: DropDownItemChoice) => (

                            <div
                                key={choice.value}
                                onClick={() => {
                                    props.onChange?.({
                                        target: { value: choice.value }
                                    } as any);
                                    setOpen(false);
                                }}
                                style={{
                                    padding: "6px 2px",
                                    cursor: "pointer",
                                    transition: "background 0.15s"
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#005ea2";
                                    e.currentTarget.style.color = "white";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "transparent";
                                    e.currentTarget.style.color = "black";
                                }}
                            >
                                {choice.label}
                            </div>

                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default SearchableDropdown;